<div *ngIf="currentEnv == 'emvs'">
    <div class="page__content">
      <div class="content__inner">
        <div class="register-form">
          <div class="row">
            <div class="col-sm-12">
              <h5 id="solicitud-titulo">{{procedimiento.nombre}}
              </h5>
            </div>
          </div>
  
          <ul class="nav nav-tabs nav-stepper" id="myTab" role="tablist">
            <li class="nav-item">
              <a  [ngClass]="esNavegable('personales-tab')" class="active" id="personales-tab" data-toggle="tab" href="#personales" role="tab" 
                aria-controls="home" aria-selected="true" (click)="restauraPestaniaSeleccionada('personales-tab')">
                <span >{{ 'REGISTER.PERSONAL_DATA' | translate }}</span>
              </a>
            </li>
           
            
            <li class="nav-item">
              <a [ngClass]="esNavegable('puestos-tab')" id="puestos-tab" data-toggle="tab" href="#puestos" role="tab" 
                aria-controls="contact" aria-selected="false" (click)="restauraPestaniaSeleccionada('puestos-tab')">Puestos solicitados</a>
            </li>
  
            <li class="nav-item" >
              <a [ngClass]="esNavegable('politicas-tab')" id="politicas-tab" data-toggle="tab" href="#politicas" role="tab" 
                aria-controls="contact" aria-selected="false" (click)="restauraPestaniaSeleccionada('politicas-tab')">Política de privacidad</a>
            </li>
          </ul>
          <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate" [fullScreen] = "true">
            <p style="color: white" >{{mensajeSpinner}}</p>
          </ngx-spinner>
          <div class="tab-content" id="myTabContent">
  
            <div class="tab-pane fade show active" id="personales" role="tabpanel" aria-labelledby="personales-tab">
  
              <div>
                <h3 class="tabtitle">DATOS PERSONALES</h3>
                <div class="row mt-3">
                  <div class="col-sm-4 spacing-box" *ngIf="this.currentUser.tipopersona.id == 1">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PRIMER_APELLIDO' | translate }}</label>
                    <input id="apellido1" name="apellido1" type="text" [ngModel]="this.currentUser.apellido1"
                      class="form-control" disabled />
                  </div>
                  <div class="col-sm-4 spacing-box" *ngIf="this.currentUser.tipopersona.id == 1">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.SEGUNDO_APELLIDO' | translate }}</label>
                    <input id="apellido2" name="apellido2" type="text" [ngModel]="this.currentUser.apellido2"
                      class="form-control" disabled>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ (this.currentUser.tipopersona.id == 1 ? 'TRAMITE.FORM.LABEL.NOMBRE' : 'TRAMITE.FORM.LABEL.RAZON_SOCIAL') | translate }}</label>
                    <input id="nombre" name="nombre" type="text" [ngModel]="this.currentUser.nombre" class="form-control"
                      disabled />
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE_LIST.COLUMN.DNI' | translate }}</label>
                    <input id="numero_documento" name="numero_documento" type="text"
                      [ngModel]="this.currentUser.numero_documento" class="form-control" disabled />
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_VIA' | translate }}</label>
                    <input id="tipovia" name="tipovia" type="text" [ngModel]="this.activeAddress.type_of_road.tipovia"
                      class="form-control" disabled>
                  </div>
                  <div class="col-sm-6 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.DIRECCION_CALLE_PLAZA_AVENIDA_ETC' | translate }}</label>
                    <input id="name_road" name="name_road" type="text" [ngModel]="this.activeAddress.name_road"
                      class="form-control" disabled>
                  </div>
                  <div class="col-sm-1 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N' | translate }}</label>
                    <input id="number_road" name="number_road" type="text" [ngModel]="this.activeAddress.number_road"
                      class="form-control" disabled>
                  </div>
                  <div *ngIf="activeAddress.block" class="col-sm-1 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PORTAL' | translate }}</label>
                    <input type="text" id="block" name="block"
                      [ngModel]="this.activeAddress.block" class="form-control"
                      disabled>
                  </div>
  
                  <div *ngIf="activeAddress.stairs" class="col-sm-1 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.ESCALERA' | translate }}</label>
                    <input type="text" id="stairs" name="stairs"
                      [ngModel]="this.activeAddress.stairs" class="form-control"
                      disabled>
                  </div>
  
                  <div *ngIf="activeAddress.floor" class="col-sm-1 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PLANTA' | translate }}</label>
                    <input type="text" id="floor" name="floor"
                      [ngModel]="this.activeAddress.floor" class="form-control"
                      disabled>
                  </div>
  
                  <div *ngIf="activeAddress.door" class="col-sm-1 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PUERTA' | translate }}</label>
                    <input type="text" id="door" name="door"
                      [ngModel]="this.activeAddress.door" class="form-control"
                      disabled>
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                    <input id="postal_code" name="postal_code" type="text" [ngModel]="this.activeAddress.postal_code"
                      class="form-control" disabled>
                  </div>
                  <div class="col-sm-3 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                    <input id="province" name="province" class="w-100 form-control"
                      [ngModel]="activeAddress.province.nombre" disabled />
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                    <input id="nameMunicipality" name="nameMunicipality" [ngModel]="municipioNombre"
                      class="w-100 form-control" disabled />
                  </div>
                  <div class="col-sm-3 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO' | translate }}</label>
                      <input id="telefono" name="telefono" type="text" [ngModel]="this.currentUser.telefono"
                        class="form-control" disabled />
                    </div>
                  </div>
                </div>
                <div>
                  <form [formGroup]="formDatosPersonales" (ngSubmit)="onSubmitDatos()">
                    <div class="row border col-sm-7 p-3 d-flex justify-content-center mt-5">
                      <div class="col-sm-4 mr-5">
                        <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.FECHA_NACIMIENTO' | translate }}</label>
                        <input id="fecha_nacimiento" name="fecha_nacimiento" type="date"
                          formControlName="fecha_nacimiento" class="form-control" 
                          [ngClass]="{'is-invalid': submitted && formDatosPersonales.controls['fecha_nacimiento'].errors}"/>
                      </div>
                      <div class="col-sm-7">
                        <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TITULACION' | translate }}</label>
                        <input id="titulacion" name="titulacion" type="text" formControlName="titulacion"
                          class="form-control" [ngClass]="{'is-invalid': submitted && formDatosPersonales.controls['titulacion'].errors}"/>
                      </div>
                    </div>
                    <div class="col-sm-12 mt-3">
                      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>                    
                        <button type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
  
  
            <div class="tab-pane fade" id="politicas" role="tabpanel"
              aria-labelledby="politicas-tab">
              <form [formGroup]="formPoliticas">
                <h3 class="tabtitle">Política de privacidad</h3>
                <!-- <p>{{lopd}}</p> -->
                <div [innerHTML]="lopd"></div>
                <div class="smallInfo pl-3">
                  <label class="form-check-label"><input class="form-check-input position-static" type="checkbox" formControlName="politicas" id="politicas"[value]=""/>
                   He leído y acepto las Políticas de privacidad</label>
                </div>
                <div class="col-sm-12">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button [disabled]="isSigning" type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button  [disabled]="isSigning" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>                    
                    <!--<button [disabled]="isSigning" type="submit" (click)="onSubmitPoliticas()"
                      class="btn btn-primary mt-2">{{ 'TRAMITE.CONTENT.FINALIZAR' | translate }}</button>-->
                    <fieldset [disabled]="isSigning">
                      <boton-listado>                  
                      </boton-listado>
                    </fieldset>
                  </div>
                </div>
              </form>
            </div>
            <div class="tab-pane fade" id="puestos" role="tabpanel"
              aria-labelledby="puestos-tab">
              <form [formGroup]="formPuestos">
                <h3 class="tabtitle">PUESTOS SOLICITADOS</h3>
                <div class="d-flex justify-content-center">
                  <div class="alertPuestos">
                    <img src="assets/triangle-exclamation.svg" class="iconAlert"/>{{ 'TRAMITE.CONTENT.ANEXO3_MULTI_PUESTO' | translate }}
                  </div>
                </div>
                <div formArrayName="puesto" class="mt-3 d-flex justify-content-center">
                  <table>
                    <tr class="text-center">
                      <td>{{ 'TRAMITE.CONTENT.N_ORDEN_CONVOCATORIA' | translate }}</td>
                      <td>{{ 'TRAMITE.CONTENT.DENOMINACION_DEL_PUESTO' | translate }}</td>
                    </tr>
                    <tr class="mt-3" *ngFor="let passengerGroup of puesto?.controls; let i = index" [formGroupName]="i">
                      <td class="text-center">{{i+1}}<input type="hidden" formControlName="convocatoria" [ngModel]="i + 1"
                          class="form-control"></td>
                      <td>
                        <select formControlName="denominacion" class="form-control"
                          [ngClass]="{'is-invalid': submitPuestos && puesto.controls[i].get('denominacion').errors}" (change)="addPuestoArray()">
                          <option [hidden]="arrayAuxPuestos.includes(denominacion)"  *ngFor="let denominacion of denominacionPuesto" [value]="denominacion.id" >
                            {{ denominacion.nombre }} - {{ denominacion.puesto }}
                          </option>
                        </select>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="col-sm-12 pt-2">
                  <div class="form-group">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <div *ngIf="puesto.length != 1">
                        <button type="button" (click)="deletePuesto()" class="btn btn-danger mr-2">{{ 'TRAMITE.CONTENT.ELIMINAR_PUESTO' | translate }}</button>
                      </div>
                      <div *ngIf="puesto.length < 10">
                        <button type="button" (click)="addPuesto()" class="btn btn-primary">{{ 'TRAMITE.CONTENT.ANADIR_PUESTO' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="col-sm-12 mt-5 d-flex">
                  <div class="col-sm-3">
                    <label class="font-weight-bold col-sm-12 requerido titleFiles"
                      [ngClass]="{'invalid-file': submitPuestos && formPuestos.controls['documento'].errors}">{{ 'TRAMITE.FORM.LABEL.ADJUNTE_SU_CURRICULUM' | translate }}</label>
                    <label class="col-sm-12 smallInfoFiles">{{ 'TRAMITE.FORM.LABEL.TAMANO_MAXIMO_15MB' | translate }}</label>
                  </div>
                  <input type="file" accept="application/pdf" (change)="onFileChange($event, 'documento')">
                </div> 
                <div class="col-sm-12 mt-5 d-flex" *ngIf="nombreFilePuesto1">
                  <div class="col-sm-3" >              
                      <label class="font-weight-bold col-sm-12 titleFiles">{{ 'TRAMITE.FORM.LABEL.NOMBRE_DOCUMENTO_SUBIDO' | translate }}</label>                                    
                  </div>
                  <td>{{nombreFilePuesto1}}</td>
                </div>
                <div class="col-sm-12 mt-5 d-flex">
                  <div class="col-sm-3">
                  <label class="font-weight-bold col-sm-12 requerido titleFiles"
                    [ngClass]="{'invalid-file': submitPuestos && formPuestos.controls['documento2'].errors}">{{ 'TRAMITE.FORM.LABEL.ADJUNTE_SU_CERTIFICADO_DE_TITULACION_MINIMA_EXIGIDA' | translate }}</label>
                    <label class="col-sm-12 smallInfoFiles">{{ 'TRAMITE.FORM.LABEL.TAMANO_MAXIMO_15MB' | translate }}</label>
                  </div>
                  <input type="file" accept="application/pdf" (change)="onFileChange($event, 'documento2')">
                </div>
                <div class="col-sm-12 mt-5 d-flex" *ngIf="nombreFilePuesto1">
                  <div class="col-sm-3" >              
                      <label class="font-weight-bold col-sm-12 titleFiles">{{ 'TRAMITE.FORM.LABEL.NOMBRE_DOCUMENTO_SUBIDO' | translate }}</label>                                    
                  </div>
                  <td>{{nombreFilePuesto2}}</td>
                </div> 
                <div class="col-sm-12 mt-5 p-3 d-flex">
                  <div class="checkbox-custom col-sm-1">
                    <input class="form-check-input position-static" type="checkbox" formControlName="check1" [value]=""/>
                  </div>
                  <p class="smallInfo col-sm-11">{{ 'TRAMITE.CONTENT.SOLICITO_PARTICIPAR_EN_EL_CONCURSO_A_QUE_SE_REFIERE_LA_PRESENTE_INSTANCIA_Y_DECL' | translate }}</p>
                  
                </div>
  
                <div class="col-sm-12">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button [disabled]="uploadDocuments" type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button  [disabled]="uploadDocuments" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>    
                    <button type="submit" [disabled]="uploadDocuments" (click)="onSubmitPuestos()" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
  
            <div class="tab-pane fade" id="representacionReducida" role="tabpanel" aria-labelledby="representacionReducida-tab">
              <h3 class="tabtitle">DATOS PERSONALES DEL REPRESENTANTE</h3>
              <form [formGroup]="formRepresentanteReducido" (ngSubmit)="onSubmitRepresentado()">
                <div class="row p-2 mt-4 mr-0 ml-0">
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                    <input type="text" formControlName="documento_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['documento_representado'].errors}"/>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.APELLIDOS' | translate }}</label>
                    <input type="text" formControlName="apellidos_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['apellidos_representado'].errors}">
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'PROCEDIMIENTO.EDIT.NAME' | translate }}</label>
                    <input type="text" formControlName="nombre_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['nombre_representado'].errors}"/>
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_VIA' | translate }}</label>
                    <select formControlName="tipo_via_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['tipo_via_representado'].errors}">
                      <option *ngFor="let vias of TVias" [value]="vias.id">
                          {{ vias.tipovianormalizado }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-8 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.DIRECCION' | translate }}</label>
                    <input type="text" formControlName="direccion_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['direccion_representado'].errors}">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N_DE_CALLE' | translate }}</label>
                    <input type="text" formControlName="numero_calle_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['numero_calle_representado'].errors}">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PORTAL' | translate }}</label>
                    <input type="text" formControlName="portal_representado" class="form-control">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.ESCALERA' | translate }}</label>
                    <input type="text" formControlName="escalera_representado" class="form-control">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PLANTA' | translate }}</label>
                    <input type="text" formControlName="planta_representado" class="form-control">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PUERTA' | translate }}</label>
                    <input type="text" formControlName="puerta_representado" class="form-control">
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                    <input type="text" mask="9{5}" formControlName="cp_representado" class="form-control"
                      [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['cp_representado'].errors}">
                  </div>
                  <div class="col-sm-6 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                    <select formControlName="provincia_representado" class="form-control"
                      (change)="onChangeMunicipio($event)" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['provincia_representado'].errors}">
                      <option *ngFor="let prov of TProvincias" [value]="prov.id">
                        {{ prov.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                    <select formControlName="municipio_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['municipio_representado'].errors}">
                      <option *ngFor="let loc of TMunicipios" [value]="loc.municipioPK['municipio_id']">
                        {{ loc.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CORREO_ELECTRONICO' | translate }}</label>
                      <input type="text" formControlName="email_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['email_representado'].errors}"/>
                    </div>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_1' | translate }}</label>
                      <input type="text" formControlName="telefono1_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['telefono1_representado'].errors}"/>
                    </div>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_2' | translate }}</label>
                      <input type="text" formControlName="telefono2_representado" class="form-control"  [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['telefono2_representado'].errors}"/>
                    </div>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.GENERO' | translate }}</label>
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="genero_representado" name="inlineRadioOptions" id="inlineRadio1" value="Hombre">
                        <label class="form-check-label" for="inlineRadio1">{{ 'TRAMITE.FORM.LABEL.HOMBRE' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="genero_representado" name="inlineRadioOptions" id="inlineRadio2" value="Mujer">
                        <label class="form-check-label" for="inlineRadio2">{{ 'TRAMITE.FORM.LABEL.MUJER' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="genero_representado" name="inlineRadioOptions" id="inlineRadio3" value="Otros">
                        <label class="form-check-label" for="inlineRadio3">{{ 'TRAMITE.FORM.LABEL.OTROS' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                      <button  [disabled]="uploadDocuments" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button> 
                      <button [disabled]="uploadDocuments" type="submit" class="btn btn-primary m-right mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
  
            <div class="tab-pane fade" id="representacion" role="tabpanel" aria-labelledby="representacion-tab">
              <h3 class="tabtitle">DATOS PERSONALES DEL SOLICITANTE</h3>
              <div class="row border p-2 mt-4 mr-0 ml-0">
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                  <input type="text" [ngModel]="this.currentUser.numero_documento" class="form-control" disabled />
                </div>
                <div class="col-sm-4 spacing-box" *ngIf="this.currentUser.tipopersona.id == 1">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.APELLIDOS' | translate }}</label>
                  <input type="text" [ngModel]="this.currentUser.apellido1 + ' ' + this.currentUser.apellido2 "
                    class="form-control" disabled>
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ (this.currentUser.tipopersona.id == 1 ? 'TRAMITE.FORM.LABEL.NOMBRE' : 'TRAMITE.FORM.LABEL.RAZON_SOCIAL') | translate }}</label>
                  <input type="text" [ngModel]="this.currentUser.nombre" class="form-control" disabled />
                </div>
                <div class="col-sm-8 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.DIRECCION' | translate }}</label>
                  <input type="text" [ngModel]="this.activeAddress.name_road" class="form-control" disabled />
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                  <input type="text" [ngModel]="this.activeAddress.postal_code" class="form-control" disabled>
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                  <input class="w-100 form-control" [(ngModel)]="activeAddress.province.nombre" disabled />
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                  <input class="w-100 form-control" [(ngModel)]="municipioNombre" disabled />
                </div>
  
                <div class="col-sm-4 spacing-box">
                  <div class="form-group">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO' | translate }}</label>
                    <input [ngModel]="this.currentUser.telefono" type="text" class="form-control" disabled />
                  </div>
                </div>
              </div>
  
              <h3 class="tabtitle mt-5">DATOS PERSONALES DEL REPRESENTANTE</h3>
              <form [formGroup]="formRepresentante" (ngSubmit)="onSubmitRepresentado()">
                <div class="row border p-2 mt-4 mr-0 ml-0">
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                    <input type="text" formControlName="documento_representado" class="form-control" />
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.APELLIDOS' | translate }}</label>
                    <input type="text" formControlName="apellidos_representado" class="form-control">
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'PROCEDIMIENTO.EDIT.NAME' | translate }}</label>
                    <input type="text" formControlName="nombre_representado" class="form-control" />
                  </div>
                  <div class="col-sm-8 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.DIRECCION' | translate }}</label>
                    <input type="text" formControlName="direccion_representado" class="form-control">
                  </div>          
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                    <input type="text" mask="9{5}" formControlName="cp_representado" class="form-control"
                      [ngClass]="{'is-invalid': submitRepresentante && formRepresentante.controls['cp_representado'].errors}">
                  </div>
                  <div class="col-sm-6 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                    <select formControlName="provincia_representado" class="form-control"
                      (change)="onChangeMunicipio($event)">
                      <option *ngFor="let prov of TProvincias" [value]="prov.id">
                        {{ prov.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                    <select formControlName="municipio_representado" class="form-control">
                      <option *ngFor="let loc of TMunicipios" [value]="loc.municipioPK['municipio_id']">
                        {{ loc.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CORREO_ELECTRONICO' | translate }}</label>
                      <input type="text" formControlName="email_representado" class="form-control" />
                    </div>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_1' | translate }}</label>
                      <input type="text" formControlName="telefono1_representado" class="form-control" />
                    </div>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_2' | translate }}</label>
                      <input type="text" formControlName="telefono2_representado" class="form-control" />
                    </div>
                  </div>
                </div>
                <h3 class="tabtitle mt-5">AUTORIZACIÓN EXPRESA</h3>
                <div class="row border p-2 mt-4 mr-0 ml-0">
                  <div class="col-sm-12 d-flex">
                    <div class="form-group col-sm-6">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.D_D' | translate }}</label>
                      <input type="text" formControlName="nombre1_autorizacion" class="form-control" />
                    </div>
                    <div class="form-group col-sm-6">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CON_DNI' | translate }}</label>
                      <input type="text" formControlName="dni1_autorizacion" class="form-control" />
                    </div>
                  </div>
                  <div class="col-sm-12 d-flex">
                    <div class="form-group col-sm-6">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.AUTORIZA_A_D_D' | translate }}</label>
                      <input type="text" formControlName="nombre2_autorizacion" class="form-control" />
                    </div>
                    <div class="form-group col-sm-6">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CON_DNI' | translate }}</label>
                      <input type="text" formControlName="dni2_autorizacion" class="form-control" />
                    </div>
                  </div>
                  <div class="col-sm-12 d-flex">
                    <div class="col-sm-6">
                      <p class="col-sm-12 spacing-box">{{ 'TRAMITE.CONTENT.EL_REPRESENTADO_ACEPTA_DICHA_REPRESENTACION' | translate }}</p>
                      <p class="col-sm-12 spacing-box">{{ 'TRAMITE.CONTENT.SE_ADJUNTA_EL_DNI_DEL_REPRESENTANTE_Y_DEL_REPRESENTADO' | translate }}</p>
                    </div>
                  </div>
                  <div class="col-sm-12 d-flex">
                    <div class="col-sm-6">
                      <div class="col-sm-12 d-flex align-items-center">
                        <p class="col-sm-6 spacing-box">{{ 'TRAMITE.CONTENT.ADJUNTAR_DOCUMENTOS' | translate }}</p>
                        <div class="custom-file">
                          <input type="file"  accept="application/pdf" class="custom-file-input" id="customFileLang" (change)="handleUpload($event)">
                          <label class="custom-file-label" data-browse="Elegir" for="customFileLang">{{ 'TRAMITE.FORM.LABEL.SELECCIONAR_ARCHIVO' | translate }}</label>
                        </div>
                      </div>
                      <p class="text-center">{{ 'TRAMITE.CONTENT.DOCUMENTOS_ADJUNTOS' | translate }}</p>
                      <table class="table table-striped">
                        <tr>
                          <td class="tinyLabel">{{ 'TRAMITE.CONTENT.NOMBRE_DOCUMENTO' | translate }}</td>
                        </tr>
                        <tr *ngFor="let documento of this.mapDocumentos">
                          <td>{{documento['nameDocument'] }}</td>
                          <td><button (click)="removeFile(mapDocumentos.indexOf(documento))"
                              class="btn btn-danger">{{ 'TRAMITE.FILE.DELETE' | translate }}</button></td>
                        </tr>
                      </table>  
                    </div>
                  </div>
                  
                  <div class="col-sm-12 d-flex">
                    <p class="col-sm-12 spacing-box">{{ 'TRAMITE.CONTENT.NOTA_LA_AUTORIZACION_CONCEDIDA_POR_LOS_FIRMANTES_PUEDE_SER_REVOCADA_EN_CUALQUIER' | translate }}</p>
                  </div>
                </div>
                <div class="row border p-2 spacing-box mr-0 ml-0">
                  <label class="w-100 clausula"><u>Cláusula de Privacidad</u></label>
                  <p class="smallInfo p-3">{{ 'TRAMITE.CONTENT.LOS_DATOS_PERSONALES_RECOGIDOS_EN_ESTE_FORMULARIO_SERAN_TRATADOS_DE_CONFORMIDAD_' | translate }}</p>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <button [disabled]="uploadDocuments" type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                      <button  [disabled]="uploadDocuments" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button> 
                      <button [disabled]="uploadDocuments" type="submit" class="btn btn-primary m-right mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="tab-pane fade" id="circunstancias" role="tabpanel" aria-labelledby="circunstancias-tab">
              <form [formGroup]="formCircunstancias" (ngSubmit)="onSubmitCircunstancias()">
                <h3 class="tabtitle">{{ 'TRAMITE.TITLES.ECONOMIC_FAMILY_PERSONAL' | translate }}</h3>
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <span class="manual-help activo"><a class="icons-tramite"
                        href="assets/emvs/ayudas/Instrucciones de inscripción en el RPSV.pdf"
                        target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                          title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.ACREDITA_RESIDENCIA_EN_EL_MUNICIPIO_DE_MADRID_DE_AL_MENOS_1_ANO_ININTERRUMPIDO_C' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1"
                          name="inlineRadioOptions1" id="inlineRadioPregunta1si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta1si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1"
                          name="inlineRadioOptions1" id="inlineRadioPregunta1no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta1no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.EN_CASO_DE_NO_ACREDITAR_EMPADRONAMIENTO_DESARROLLA_SU_ACTIVIDAD_LABORAL_EN_EL_MU' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2"
                          name="inlineRadioOptions2" id="inlineRadioPregunta2si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta2si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2"
                          name="inlineRadioOptions2" id="inlineRadioPregunta2no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta2no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.USTED_O_ALGUN_MIEMBRO_DE_SU_UNIDAD_FAMILIAR_TIENE_UNA_DISCAPACIDAD_CON_MOVILIDAD' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3"
                          name="inlineRadioOptions3" id="inlineRadioPregunta3si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta3si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3"
                          name="inlineRadioOptions3" id="inlineRadioPregunta3no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta3no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.SI_LA_PREGUNTA_ANTERIOR_ES_AFIRMATIVA_TIENE_NECESIDAD_DE_AYUDA_DE_TERCERA_PERSON' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4"
                          name="inlineRadioOptions4" id="inlineRadioPregunta4si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta4si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4"
                          name="inlineRadioOptions4" id="inlineRadioPregunta4no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta4no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.TIENE_USTED_TITULO_DE_FAMILIA_NUMEROSA_EN_VIGOR' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5"
                          name="inlineRadioOptions5" id="inlineRadioPregunta5si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta5si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5"
                          name="inlineRadioOptions5" id="inlineRadioPregunta5no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta5no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.ES_USTED_UNA_FAMILIA_MONOPARENTAL_PADRE_O_MADRE_QUE_NO_CONVIVE_EN_PAREJA_CON_HIJ' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6"
                          name="inlineRadioOptions6" id="inlineRadioPregunta6si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta6si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6"
                          name="inlineRadioOptions6" id="inlineRadioPregunta6no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta6no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.TIENE_USTED_VIVIENDA_EN_PROPIEDAD_INDEPENDIENTEMENTE_DEL_TITULO_O_PORCENTAJE_SOB' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta7"
                          name="inlineRadioOptions7" id="inlineRadioPregunta7si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta7si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta7"
                          name="inlineRadioOptions7" id="inlineRadioPregunta7no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta7no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.ES_USTED_ARRENDATARIO_A_DE_UNA_VIVIENDA_EN_PROPIEDAD_O_GESTIONADA_POR_EMVS_MADRI' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta8"
                          name="inlineRadioOptions8" id="inlineRadioPregunta8si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta8si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta8"
                          name="inlineRadioOptions8" id="inlineRadioPregunta8no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta8no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.ES_USTED_VICTIMA_DIRECTA_O_INDIRECTA_DE_VIOLENCIA_DE_GENERO_TRATA_Y_O_EXPLOTACIO' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta9"
                          name="inlineRadioOptions9" id="inlineRadioPregunta9si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta9si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta9"
                          name="inlineRadioOptions9" id="inlineRadioPregunta9no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta9no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.ACREDITA_CONDICION_DE_REFUGIADO_A' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta10"
                          name="inlineRadioOptions10" id="inlineRadioPregunta10si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta10si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta10"
                          name="inlineRadioOptions10" id="inlineRadioPregunta10no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta10no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.SE_ENCUENTRA_ACTUALMENTE_OCUPANDO_UNA_VIVIENDA_INMUEBLE_DE_EMVS_MADRID_O_DEL_AYU' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta11"
                          name="inlineRadioOptions11" id="inlineRadioPregunta11si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta11si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta11"
                          name="inlineRadioOptions11" id="inlineRadioPregunta11no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta11no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex">
                  <div class="w80">
                    <p>{{ 'TRAMITE.CONTENT.HA_SIDO_LANZADO_JUDICIALMENTE_POR_OCUPACION_DE_UNA_VIVIENDA_DE_TITULARIDAD_O_GES' | translate }}</p>
                  </div>
                  <div class="w-25">
                    <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta12"
                          name="inlineRadioOptions12" id="inlineRadioPregunta12si" value="Sí">
                        <label class="form-check-label" for="inlineRadioPregunta12si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta12"
                          name="inlineRadioOptions12" id="inlineRadioPregunta12no" value="No">
                        <label class="form-check-label" for="inlineRadioPregunta12no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                      <button   type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button> 
                      <button type="submit" class="btn btn-primary m-right mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="tab-pane fade" id="unidad" role="tabpanel" aria-labelledby="unidad-tab">
              <form [formGroup]="formUnidadFamiliar" (ngSubmit)="onSubmitUnidadFamiliar()">
                <h3 class="tabtitle">{{ 'TRAMITE.TITLES.FAMILY_UNIT_DATA' | translate }}</h3>
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <span class="manual-help activo"><a class="icons-tramite"
                        href="assets/emvs/ayudas/Instrucciones de inscripción en el RPSV.pdf"
                        target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                          title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                  </div>
                </div>
                <div formArrayName="familiar">
                  <table>
                    <tr>
                      <td class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.DNI_NIE' | translate }}</td>
                      <td class="tinyLabel">{{ 'TRAMITE.CONTENT.APELLIDOS_Y_NOMBRE' | translate }}</td>
                      <td class="tinyLabel">{{ 'TRAMITE.CONTENT.FECHA_NACIMIENTO' | translate }}</td>
                      <td class="tinyLabel">{{ 'TRAMITE.CONTENT.PARENTESCO' | translate }}</td>
                      <td class="tinyLabel">{{ 'TRAMITE.CONTENT.ESTADO_CIVIL' | translate }}</td>
                      <td class="tinyLabel">{{ 'TRAMITE.CONTENT.GRADO_DE_DISCAPACIDAD' | translate }}</td>
                      <td class="tinyLabel">{{ 'TRAMITE.CONTENT.GRADO_DE_DEPENDENCIA' | translate }}</td>
                    </tr>
                    <tr *ngFor="let passengerGroup of familiar?.controls; let i = index" [formGroupName]="i">
                      <td><input type="text" formControlName="documento" class="form-control" [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('documento').errors}"></td>
                      <td><input type="text" formControlName="apellidos_nombre" class="form-control" [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('apellidos_nombre').errors}"></td>
                      <td><input type="date" formControlName="fecha_nacimiento" class="form-control" [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('fecha_nacimiento').errors}">
                      </td>
                      <td><input type="text" formControlName="parentesco" class="form-control" [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('parentesco').errors}"></td>
                      <td><select formControlName="estado_civil" class="form-control" [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('estado_civil').errors}">
                          <option *ngFor="let estado of estadosCiviles" [value]="estado.id">
                            {{ estado.nombre }}
                          </option>
                        </select></td>
                      <td><select formControlName="grado_discapacidad" class="form-control" [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('grado_discapacidad').errors}">
                          <option *ngFor="let grado of gradosDiscapacidad" [value]="grado.id">
                            {{ grado.nombre }}
                          </option>
                        </select></td>
                      <td><select formControlName="grado_dependencia" class="form-control" [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('grado_dependencia').errors}">
                          <option *ngFor="let grado of gradosDependencia" [value]="grado.id">
                            {{ grado.nombre }}
                          </option>
                        </select></td>
                    </tr>
                  </table>
  
                </div>
                <div class="col-sm-12 pt-2">
                  <div class="form-group">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <div *ngIf="familiar.length != 1">
                        <button type="button" (click)="deleteFamiliar()" class="btn btn-danger mr-2">{{ 'TRAMITE.CONTENT.ELIMINAR_FAMILIAR' | translate }}</button>
                      </div>
                      <button type="button" (click)="addFamiliar()" class="btn btn-primary">{{ 'TRAMITE.CONTENT.ANADIR_FAMILIAR' | translate }}</button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 pt-2">
                  <div class="form-group">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                      <button  type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button> 
                      <button type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="tab-pane fade" id="distritos" role="tabpanel" aria-labelledby="distritos-tab">
              <form [formGroup]="formDistritos" (ngSubmit)="onSubmitDistritos()">
                <h3 class="tabtitle">{{ 'TRAMITE.TITLES.MUNICIPAL_DISTRICTS' | translate }}</h3>
                <div class="row">
                  <div class="col-sm-12">
                    <span class="manual-help activo"><a class="icons-tramite"
                        href="assets/emvs/ayudas/Instrucciones de inscripción en el RPSV.pdf"
                        target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                          title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                  </div>
                </div>
                <div>
                  <div class="border mt-3 pl-4 pt-2">
                    <div class="row">
                      <div class="w-100 d-flex">
                        <div class="w-25">
                          <label class="font-weight-bold">{{ 'TRAMITE.FORM.LABEL.A_TODAS_LAS_ZONAS' | translate }}</label>
                        </div>
                        <div class="w-25 form-check">
                          <input class="form-check-input position-static" type="checkbox" formControlName="todas_zonas"
                            [value]=""/>
                        </div>
                      </div>
                      <div class="w-100">
                        <p class="w=100">{{ 'TRAMITE.CONTENT.SE_SELECCIONARA_UNA_VIVIENDA_EN_CUALQUIER_DISTRITO_DONDE_EXISTAN_VIVIENDAS_DISPO' | translate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="border mt-3 p-3">
                  <label class="font-weight-bold">{{ 'TRAMITE.FORM.LABEL.B_CON_SELECCION_DE_ZONA' | translate }}</label>
  
                  <div class="w-100">
                    <p class="w=100">{{ 'TRAMITE.CONTENT.ENUMERAR_POR_ORDEN_DE_PREFERENCIA_LA_ELECCION_HA_DE_SER_EXCLUSIVAMENTE_NUMERICA_' | translate }}</p>
                  </div>
                  <div class="row mt-2">
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.1_CENTRO' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="centro" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.8_FUENCARRAL_EL_PARDO' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="fuencarral_pardo" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.15_CIUDAD_LINEAL' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="ciudad_lineal" class="form-control" mask="9{2}">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.2_ARGANZUELA' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="arganzuela" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.9_MONCLOA' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="moncloa" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.16_HORTALEZA' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="hortaleza" class="form-control" mask="9{2}">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.3_RETIRO' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="retiro" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.10_LATINA' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="latina" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.17_VILLAVERDE' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="villaverde" class="form-control" mask="9{2}">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.4_SALAMANCA' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="salamanca" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.11_CARABANCHEL' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="carabanchel" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.18_VALLECAS_VILLA' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="vallecas_villa" class="form-control" mask="9{2}">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.5_CHAMARTIN' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="chamartin" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.12_USERA' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="usera" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.19_VICALVARO' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="vilcalvaro" class="form-control" mask="9{2}">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.6_TETUAN' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="tetuan" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.13_PUENTE_DE_VALLECAS' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="puente_vallecas" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.20_SAN_BLAS' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="san_blas" class="form-control" mask="9{2}">
                    </div>
                  </div>
                  <div class="row mt-2">
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.7_CHAMBERI' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="chamberi" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.14_MORATALAZ' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="moratalaz" class="form-control" mask="9{2}">
                    </div>
                    <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.21_BARAJAS' | translate }}</label>
                    <div class="col-sm-1">
                      <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null" type="text" formControlName="barajas" class="form-control" mask="9{2}">
                    </div>
                  </div>
                </div>
                <div class="w-100 mt-3">
                  <p>{{ 'TRAMITE.CONTENT.EL_APARTADO_A_Y_B_SON_EXCLUYENTES_ENTRE_SI_DANDOSE_PREFERENCIA_AL_APARTADO_A_EN_' | translate }}</p>
                </div>
                <div class="col-sm-12 pt-2">
                  <div class="form-group">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                      <button  type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button> 
                      <button type="submit" class="btn btn-primary  mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="tab-pane fade" id="vulnerabilidad" role="tabpanel" aria-labelledby="vulnerabilidad-tab">
              <form [formGroup]="formVulnerabilidad" (ngSubmit)="onSubmitVulnerabilidad()">
                <h3 class="tabtitle">ANEXO 1 SITUACIÓN VULNERABILIDAD RESIDENCIAL</h3>
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <span class="manual-help activo"><a class="icons-tramite"
                        href="assets/emvs/ayudas/Instrucciones de inscripción en el RPSV.pdf"
                        target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                          title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <label>{{ 'TRAMITE.FORM.LABEL.1_EN_QUE_TIPO_DE_ALOJAMIENTO_RESIDE' | translate }}</label>
                  </div>
                  <div class="ml-3 form-check">
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1" name="RadioOptions0" id="inlineRadioPregunta0A" value="A. Piso, Casa, Pensión, Hostal, habitación en vivienda compartida">
                      <label class="form-check-label" for="inlineRadioPregunta0A">{{ 'TRAMITE.FORM.LABEL.A_PISO_CASA_PENSION_HOSTAL_HABITACION_EN_VIVIENDA_COMPARTIDA' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1" name="RadioOptions0" id="inlineRadioPregunta0B" value="B. Otros alojamientos: Chabola, Caravana, Local">
                      <label class="form-check-label" for="inlineRadioPregunta0B">{{ 'TRAMITE.FORM.LABEL.B_OTROS_ALOJAMIENTOS_CHABOLA_CARAVANA_LOCAL' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1" name="RadioOptions0" id="inlineRadioPregunta0C" value="C. Alojamiento institucional: recurso temporal">
                      <label class="form-check-label" for="inlineRadioPregunta0C">{{ 'TRAMITE.FORM.LABEL.C_ALOJAMIENTO_INSTITUCIONAL_RECURSO_TEMPORAL' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1" name="RadioOptions0" id="inlineRadioPregunta0D" value="D. En la calle o albergue de forma ocasional">
                      <label class="form-check-label" for="inlineRadioPregunta0D">{{ 'TRAMITE.FORM.LABEL.D_EN_LA_CALLE_O_ALBERGUE_DE_FORMA_OCASIONAL' | translate }}</label>
                    </div>
                  </div>
                </div>
  
                <div class="row mt-5">
                  <div class="col-sm-12">
                    <label>{{ 'TRAMITE.FORM.LABEL.2_LA_SITUACION_DE_LA_VIVIENDA_DONDE_RESIDE' | translate }}</label>
                  </div>
                  <div class="ml-3">
                    <div class="form-check w-100">
                      <label>{{ 'TRAMITE.FORM.LABEL.A_TIENE_TITULO_SOBRE_LA_VIVIENDA' | translate }}</label>
                      <div class="ml-3">
                        <div class="form-check">
                          <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2" name="RadioOptions1" id="inlineRadioPregunta0A1" value="A1. Contrato de alquiler a su nombre">
                          <label class="form-check-label" for="inlineRadioPregunta0A1">{{ 'TRAMITE.FORM.LABEL.A1_CONTRATO_DE_ALQUILER_A_SU_NOMBRE' | translate }}</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2" name="RadioOptions1" id="inlineRadioPregunta0A2" value="A2. Título de propiedad a su nombre">
                          <label class="form-check-label" for="inlineRadioPregunta0A2">{{ 'TRAMITE.FORM.LABEL.A2_TITULO_DE_PROPIEDAD_A_SU_NOMBRE' | translate }}</label>
                        </div>
                      </div>
                      <label>{{ 'TRAMITE.FORM.LABEL.B_NO_TIENE_TITULO_SOBRE_LA_VIVIENDA' | translate }}</label>
                      <div class="ml-3">
                        <div class="form-check">
                          <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2" name="RadioOptions1" id="inlineRadioPregunta0B1" value="B1. Acogimiento temporal por familiares o amistades">
                          <label class="form-check-label" for="inlineRadioPregunta0B1">{{ 'TRAMITE.FORM.LABEL.B1_ACOGIMIENTO_TEMPORAL_POR_FAMILIARES_O_AMISTADES' | translate }}</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2" name="RadioOptions1" id="inlineRadioPregunta0B2" value="B2. Subarriendo o Habitación alquilada">
                          <label class="form-check-label" for="inlineRadioPregunta0B2">{{ 'TRAMITE.FORM.LABEL.B2_SUBARRIENDO_O_HABITACION_ALQUILADA' | translate }}</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2" name="RadioOptions1" id="inlineRadioPregunta0B3" value="B3. Ocupación">
                          <label class="form-check-label" for="inlineRadioPregunta0B3">{{ 'TRAMITE.FORM.LABEL.B3_OCUPACION' | translate }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="row mt-5">
                  <div class="col-sm-12">
                    <label>{{ 'TRAMITE.FORM.LABEL.3_LA_VIVIENDA_DONDE_RESIDE_TIENE_PROBLEMAS_DE_ACCESIBILIDAD_O_IMPEDIMENTOS_FISIC' | translate }}</label>
                  </div>
                  <div class="ml-3 form-check">
                    <div class=" w-100" formControlName="pregunta3">
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3" name="RadioOptions2" id="inlineRadioPregunta3A" value="A. No existen problemas de accesibilidad">
                        <label class="form-check-label" for="inlineRadioPregunta3A">{{ 'TRAMITE.FORM.LABEL.A_NO_EXISTEN_PROBLEMAS_DE_ACCESIBILIDAD' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3" name="RadioOptions2" id="inlineRadioPregunta3B" value="B. Existe algún problema o impedimento físico, pudiendo mantener su autonomía">
                        <label class="form-check-label" for="inlineRadioPregunta3B">{{ 'TRAMITE.FORM.LABEL.B_EXISTE_ALGUN_PROBLEMA_O_IMPEDIMENTO_FISICO_PUDIENDO_MANTENER_SU_AUTONOMIA' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3" name="RadioOptions2" id="inlineRadioPregunta3C" value="C. Existen importantes impedimentos o barreras arquitectónicas que impiden mantener su autonomía">
                        <label class="form-check-label" for="inlineRadioPregunta3C">{{ 'TRAMITE.FORM.LABEL.C_EXISTEN_IMPORTANTES_IMPEDIMENTOS_O_BARRERAS_ARQUITECTONICAS_QUE_IMPIDEN_MANTEN' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="row mt-5">
                  <div class="col-sm-12">
                    <label>{{ 'TRAMITE.FORM.LABEL.4_LA_VIVIENDA_DONDE_RESIDE_SE_ENCUENTRA_EN_SITUACION_DE_RIESGO_DE_PERDERLA' | translate }}</label>
                  </div>
                  <div class="ml-3">
                    <div class="form-check w-100">
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4" name="RadioOptions3" id="inlineRadioPregunta4A" value="A. NO">
                        <label class="form-check-label" for="inlineRadioPregunta4A">{{ 'TRAMITE.FORM.LABEL.A_NO' | translate }}</label>
                      </div>
                      <label>{{ 'TRAMITE.FORM.LABEL.B_SI' | translate }}</label>
                      <div class="ml-3">
                        <div class="form-check">
                          <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4" name="RadioOptions3" id="inlineRadioPregunta4B1" value="B1. Notificación legal de abandono de vivienda">
                          <label class="form-check-label" for="inlineRadioPregunta4B1">{{ 'TRAMITE.FORM.LABEL.B1_NOTIFICACION_LEGAL_DE_ABANDONO_DE_VIVIENDA' | translate }}</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4" name="RadioOptions3" id="inlineRadioPregunta4B2" value="B2. Procedimiento de desahucio vigente contra el solicitante o
                          miembros de la unidad familiar incluidos en la solicitud">
                          <label class="form-check-label" for="inlineRadioPregunta4B2">{{ 'TRAMITE.FORM.LABEL.B2_PROCEDIMIENTO_DE_DESAHUCIO_VIGENTE_CONTRA_EL_SOLICITANTE_O_MIEMBROS_DE_LA_UNI' | translate }}</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4" name="RadioOptions3" id="inlineRadioPregunta4B3" value="B3. Por encontrarse viviendo bajo una situación de violencia en el
                          domicilio">
                          <label class="form-check-label" for="inlineRadioPregunta4B3">{{ 'TRAMITE.FORM.LABEL.B3_POR_ENCONTRARSE_VIVIENDO_BAJO_UNA_SITUACION_DE_VIOLENCIA_EN_EL_DOMICILIO' | translate }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="row mt-5">
                  <div class="col-sm-12">
                    <label>{{ 'TRAMITE.FORM.LABEL.5_LA_VIVIENDA_DONDE_RESIDE_POR_LAS_DIMENSIONES_DE_LA_MISMA_ES_ADECUADA_PARA_SU_U' | translate }}</label>
                  </div>
                  <div class="ml-3">
                    <div class="form-check w-100">
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5" name="RadioOptions4" id="inlineRadioPregunta5A" value="A. Sí, el espacio es suficiente (1 persona por habitación)">
                        <label class="form-check-label" for="inlineRadioPregunta5A">{{ 'TRAMITE.FORM.LABEL.A_SI_EL_ESPACIO_ES_SUFICIENTE_1_PERSONA_POR_HABITACION' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5" name="RadioOptions4" id="inlineRadioPregunta5B" value="B. Existen algunas dificultades de espacio (2 personas por habitación)">
                        <label class="form-check-label" for="inlineRadioPregunta5B">{{ 'TRAMITE.FORM.LABEL.B_EXISTEN_ALGUNAS_DIFICULTADES_DE_ESPACIO_2_PERSONAS_POR_HABITACION' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5" name="RadioOptions4" id="inlineRadioPregunta5C" value="C. Existe hacinamiento grave (3 o más personas por habitación)">
                        <label class="form-check-label" for="inlineRadioPregunta5C">{{ 'TRAMITE.FORM.LABEL.C_EXISTE_HACINAMIENTO_GRAVE_3_O_MAS_PERSONAS_POR_HABITACION' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="row mt-5">
                  <div class="col-sm-12">
                    <label>{{ 'TRAMITE.FORM.LABEL.6_LA_VIVIENDA_DONDE_RESIDE_SE_ENCUENTRA_EN_ADECUADAS_CONDICIONES_DE_HABITABILIDA' | translate }}</label>
                  </div>
                  <div class="ml-3">
                    <div class="form-check w-100">
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6" name="RadioOptions5" id="inlineRadioPregunta6A" value="A. Sí, las condiciones de habitabilidad son adecuadas">
                        <label class="form-check-label" for="inlineRadioPregunta6A">{{ 'TRAMITE.FORM.LABEL.A_SI_LAS_CONDICIONES_DE_HABITABILIDAD_SON_ADECUADAS' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6" name="RadioOptions5" id="inlineRadioPregunta6B" value="B. Tiene una situación de cierto deterioro en cuanto al estado general
                        de la vivienda sin afectar a suministros básicos">
                        <label class="form-check-label" for="inlineRadioPregunta6B">{{ 'TRAMITE.FORM.LABEL.B_TIENE_UNA_SITUACION_DE_CIERTO_DETERIORO_EN_CUANTO_AL_ESTADO_GENERAL_DE_LA_VIVI' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6" name="RadioOptions5" id="inlineRadioPregunta6C" value="C. La vivienda se encuentra inhabitable: ausencia de los suministros
                        básicos y/o deterioro de la misma en cuanto a
                        cerramiento, ventilación y estado general">
                        <label class="form-check-label" for="inlineRadioPregunta6C">{{ 'TRAMITE.FORM.LABEL.C_LA_VIVIENDA_SE_ENCUENTRA_INHABITABLE_AUSENCIA_DE_LOS_SUMINISTROS_BASICOS_Y_O_D' | translate }}</label>
                      </div>
  
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 pt-2">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button  type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button> 
                    <button type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
  
            <div class="tab-pane fade" id="ficheros" role="tabpanel" aria-labelledby="ficheros-tab">
              <form [formGroup]="formFicheros" (ngSubmit)="onSubmitFicheros()">
                <h3 class="tabtitle">CARGA DE FICHEROS</h3>
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <span class="manual-help activo"><a class="icons-tramite"
                        href="assets/emvs/ayudas/Instrucciones de inscripción en el RPSV.pdf"
                        target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                          title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                  </div>
                </div>
  
                <div class="col-sm-12">
                  <label class="font-weight-bold">{{ 'TRAMITE.FORM.LABEL.1_LA_DOCUMENTACION_DE_CARACTER_GENERAL' | translate }}</label>
                  <div class="row border p-3">
                    <div class="col-sm-12 mb-3 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.DNI_NIE_CERTIFICADO_DE_REGISTRO_DE_CIUDADANO_DE_LA_UE_SOLO_EN_EL_CASO_DE_NO_AUTO' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'dni_nie')">
                    </div>
                    <div class="col-sm-12 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.LIBRO_DE_FAMILIA_EN_SU_DEFECTO_CERTIFICADO_DE_MATRIMONIO_CERTIFICADO_DE_NACIMIEN' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'libro_familia')">
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mb-3 p-3">
                  <label class="font-weight-bold">{{ 'TRAMITE.FORM.LABEL.2_SEGUN_TU_CASO_EL_RESTO_DE_DOCUMENTACION_NECESARIA' | translate }}</label>
                  <div class="row border p-3">
                    <div class="col-sm-12 mb-3 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.PERSONA_SEPARADA_O_DIVORCIADA_TESTIMONIO_JUDICIAL_DE_SENTENCIA_FIRME' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'separada')">
                    </div>
                    <div class="col-sm-12 mb-3 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.FAMILIA_MONOPARENTAL_TESTIMONIO_JUDICIAL_DE_OSTENTAR_LA_GUARDA_Y_CUSTODIA_DE_HIJ' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'monoparental')">
                    </div>
                    <div class="col-sm-12 mb-3 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.FAMILIA_NUMEROSA_TITULO_DE_FAMILIA_NUMEROSA_EN_VIGOR_SOLO_EN_EL_CASO_DE_NO_AUTOR' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'familia_numerosa')">
                    </div>
                    <div class="col-sm-12 mb-3 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.SI_NO_ACREDITAS_1_ANO_DE_RESIDENCIA_EN_EL_MUNICIPIO_DE_MADRID_CERTIFICADO_DE_VID' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'vida_laboral')">
                    </div>
                    <div class="col-sm-12 mb-3 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.SI_NO_ACREDITAS_1_ANO_DE_RESIDENCIA_EN_EL_MUNICIPIO_DE_MADRID_CERTIFICADO_DE_TRA' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'funcionario')">
                    </div>
                    <div class="col-sm-12 mb-3 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.MOVILIDAD_REDUCIDA_CERTIFICADO_DE_NECESIDAD_DE_VIVIENDA_ADAPTADA' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'movilidad_reducida')">
                    </div>
                    <div class="col-sm-12 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.DISCAPACIDAD_CERTIFICADO_ACREDITATIVO_DEL_GRADO_DE_DISCAPACIDAD_Y_O_DEPENDENCIA' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'discapacidad')">
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <label class="font-weight-bold">{{ 'TRAMITE.FORM.LABEL.3_SI_QUIERES_ENVIAR_OTRA_DOCUMENTACION' | translate }}</label>
                  <div class="row border p-3">
                    <div class="col-sm-12 mb-3 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.ARCHIVO_1' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'archivo1')">
                    </div>
                    <div class="col-sm-12 mb-3 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.ARCHIVO_2' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'archivo2')">
                    </div>
                    <div class="col-sm-12 d-flex">
                      <label class="col-sm-6">{{ 'TRAMITE.FORM.LABEL.ARCHIVO_3' | translate }}</label>
                      <input class="col-sm-6" type="file"  accept="application/pdf" (change)="onFileChangeFicheros($event, 'archivo3')">
                    </div>
                  </div>
                </div>
  
                <div class="col-sm-12 pt-2">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button [disabled]="uploadDocuments" type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button  [disabled]="uploadDocuments" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button> 
                    <button [disabled]="uploadDocuments" type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
            <div class="tab-pane fade" id="autorizacion" role="tabpanel" aria-labelledby="autorizacion-tab">
              <form [formGroup]="formAutorizacion" (ngSubmit)="onSubmitAutorizacion()">
                <h3 class="tabtitle">{{ 'TRAMITE.TITLES.DATA_AUTHORIZATION_PUBLIC' | translate }}</h3>
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <span class="manual-help activo"><a class="icons-tramite"
                        href="assets/emvs/ayudas/Instrucciones de inscripción en el RPSV.pdf"
                        target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                          title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                  </div>
                </div>
                <div formArrayName="autorizacion">
                  <table>
                    <tr>
                      <td>{{ 'TRAMITE.FORM.LABEL.DNI_NIE' | translate }}</td>
                      <td>{{ 'TRAMITE.CONTENT.APELLIDOS_Y_NOMBRE' | translate }}</td>
                      <td>{{ 'TRAMITE.CONTENT.FECHA_NACIMIENTO' | translate }}</td>
                      <td>{{ 'TRAMITE.CONTENT.ESTADO_CIVIL' | translate }}</td>
                      <td>{{ 'TRAMITE.CONTENT.PARENTESCO' | translate }}</td>
                    </tr>
                    <tr *ngFor="let passengerGroup of autorizacion?.controls; let i = index" [formGroupName]="i">
                      <td><input type="text" formControlName="documento" class="form-control" [ngClass]="{'is-invalid': submitAutorizacion && autorizacion.controls[i].get('documento').errors}"></td>
                      <td><input type="text" formControlName="apellidos_nombre" class="form-control" [ngClass]="{'is-invalid': submitAutorizacion && autorizacion.controls[i].get('apellidos_nombre').errors}"></td>
                      <td><input type="date" formControlName="fecha_nacimiento" class="form-control" [ngClass]="{'is-invalid': submitAutorizacion && autorizacion.controls[i].get('fecha_nacimiento').errors}">
                      </td>
                      <td><select formControlName="estado_civil" class="form-control" [ngClass]="{'is-invalid': submitAutorizacion && autorizacion.controls[i].get('estado_civil').errors}">
                          <option *ngFor="let estado of estadosCiviles" [value]="estado.id">
                            {{ estado.nombre }}
                          </option>
                        </select></td>
                      <td><input type="text" formControlName="parentesco" class="form-control" [ngClass]="{'is-invalid': submitAutorizacion && autorizacion.controls[i].get('parentesco').errors}"></td>
                    </tr>
                  </table>
                </div>
                <div class="col-sm-12 pt-2">
                  <div class="form-group">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <div *ngIf="autorizacion.length != 1">
                        <button type="button" (click)="deleteAutorizacion()" class="btn btn-danger mr-2">{{ 'TRAMITE.CONTENT.ELIMINAR_AUTORIZACION' | translate }}</button>
                      </div>
                      <button type="button" (click)="addAutorizacion()" class="btn btn-primary">{{ 'TRAMITE.CONTENT.ANADIR_AUTORIZACION' | translate }}</button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button   type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button> 
                    <button type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
            <div class="tab-pane fade" id="consulta" role="tabpanel" aria-labelledby="consulta-tab">
              <form [formGroup]="formConsulta" (ngSubmit)="onSubmitConsulta()">
                <h3 class="tabtitle">CONSULTA DE DATOS DE LA UNIDAD FAMILIAR SOLICITANTE</h3>
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <span class="manual-help activo"><a class="icons-tramite"
                        href="assets/emvs/ayudas/Instrucciones de inscripción en el RPSV.pdf"
                        target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                          title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                  </div>
                </div>
                <div class="row border p-2 ">
                  <p>{{ 'TRAMITE.CONTENT.A_EN_CASO_DE_AUTORIZAR_A_EMVS_MADRID_LA_CONSULTA_DE_DATOS_ANTE_LOS_ORGANOS_PERTI' | translate }}</p>
                  <label class="font-weight-bold text-center w-100 "><u>NO MARCAR NINGUNA CASILLA</u></label>
                </div>
  
                <div class="row border p-2">
                  <p>{{ 'TRAMITE.CONTENT.B_EN_CASO_DE_NO_AUTORIZAR_A_EMVS_MADRID_A_REALIZAR_LA_CONSULTA' | translate }}</p>
                  <label class="font-weight-bold text-center w-100 "><u>SE COMPROMETE A APORTAR LA DOCUMENTACIÓN
                      CORRESPONDIENTE A LAS CASILLAS MARCADAS</u></label>
                  <div class="w-100 d-flex">
                    <div class="w-75">
                      <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.DNI_NIE' | translate }}</label>
                    </div>
                    <div class="w-25 form-check">
                      <input class="form-check-input position-static" type="checkbox" formControlName="dni_nie"
                        [value]="">
                    </div>
                  </div>
  
                  <div class="w-100 d-flex">
                    <div class="w-75">
                      <label class="smallTitle">{{ 'TRAMITE.CONTENT.CERTIFICADO_DEL_IRPF_O_CERTIFICADO_DE_IMPUTACIONES_Y_O_PENSIONES_PUBLICAS_EXENTA' | translate }}</label>
                    </div>
                    <div class="w-25 form-check">
                      <input class="form-check-input position-static" type="checkbox" formControlName="certificado_irpf"
                        [value]="">
                    </div>
                  </div>
  
                  <div class="w-100 d-flex">
                    <div class="w-75">
                      <label class="smallTitle">{{ 'TRAMITE.CONTENT.PRESTACIONES_SOCIALES_PUBLICAS_INCAPACIDAD_TEMPORAL_Y_MATERNIDAD' | translate }}</label>
                    </div>
                    <div class="w-25 form-check">
                      <input class="form-check-input position-static" type="checkbox"
                        formControlName="prestaciones_sociales" [value]="">
                    </div>
                  </div>
  
                  <div class="w-100 d-flex">
                    <div class="w-75">
                      <label class="smallTitle">{{ 'TRAMITE.CONTENT.FAMILIA_NUMEROSA' | translate }}</label>
                    </div>
                    <div class="w-25 form-check">
                      <input class="form-check-input position-static" type="checkbox" formControlName="familia_numerosa"
                        [value]="">
                    </div>
                  </div>
  
                  <div class="w-100 d-flex">
                    <div class="w-75">
                      <label class="smallTitle">{{ 'TRAMITE.CONTENT.DISCAPACIDAD_Y_O_DEPENDENCIA' | translate }}</label>
                    </div>
                    <div class="w-25 form-check">
                      <input class="form-check-input position-static" type="checkbox"
                        formControlName="discapacidad_dependencia" [value]="">
                    </div>
                  </div>
  
                  <div class="w-100 d-flex">
                    <div class="w-75">
                      <label class="smallTitle">{{ 'TRAMITE.CONTENT.TITULARIDAD_INMUEBLES_Y_O_NOTA_SIMPLE' | translate }}</label>
                    </div>
                    <div class="w-25 form-check">
                      <input class="form-check-input position-static" type="checkbox"
                        formControlName="titularidad_inmuebles" [value]="">
                    </div>
                  </div>
  
                  <div class="w-100 d-flex">
                    <div class="w-75">
                      <label class="smallTitle">{{ 'TRAMITE.CONTENT.EMPADRONAMIENTO' | translate }}</label>
                    </div>
                    <div class="w-25 form-check">
                      <input class="form-check-input position-static" type="checkbox" formControlName="empadronamiento"
                        [value]="">
                    </div>
                  </div>
                </div>
  
                <div class="row border p-2">
                  <p class="smallInfo">Esta autorización deberá ir <strong>{{ 'TRAMITE.CONTENT.FIRMADA_POR_TODOS_LOS_MAYORES_DE_18_ANOS' | translate }}</strong>, en la casilla correspondiente de la primera tabla.
                    En caso de no autorizar a EMVS Madrid para realizar la consulta de datos, usted deberá aportar toda la
                    documentación necesaria para la inscripción y contratación en los distintos programas de
                    viviendas gestionados por EMVS Madrid.
                    Los interesados serán responsables de la veracidad de los datos y documentos que presentan, bajo las
                    posibles acciones que se pudieran iniciar en caso de falsedad u ocultación de datos y/o
                    documentos.</p>
                </div>
  
                <div class="row border p-2">
                  <label class="font-weight-bold w-100 "><u>Cláusula de Privacidad</u></label>
                  <p class="smallInfo">De conformidad con el Reglamento (UE) 2016/679 de 27 de abril de 2016, relativo a
                    la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la
                    libre
                    circulación de estos datos, y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos
                    Personales y garantía de los derechos digitales, EMVS Madrid, como responsable de sus datos
                    personales le informa que la finalidad para la que estos son recabados es consultar sus datos
                    personales con las administraciones y organismos públicos correspondientes, siendo la base
                    legitimadora del tratamiento el consentimiento de la persona interesada.
                    EMVS Madrid podrá ceder sus datos a las administraciones y organismos públicos competentes para la gestión
                    del tratamiento. No se realizarán transferencias internacionales, ni se adoptarán
                    decisiones basadas únicamente en el tratamiento automatizado de los datos personales de sus usuarios.
                    Los datos personales solicitados para esta actividad serán conservados durante el tiempo necesario
                    para la gestión de la finalidad para la que han sido recabados y, en todo caso, hasta que hayan
                    prescrito los plazos para interponer cualquier acción civil, penal o administrativa relacionada con el
                    mismo
                    En cualquier momento, el titular puede ejercer sus derechos de acceso, rectificación, supresión,
                    limitación, portabilidad, u oposición, personándose en nuestras oficinas, o dirigiéndose por escrito
                    a EMVS Madrid, ya sea por correo postal o a través de email: proteccion.datos@emvs.es. En todos los casos
                    debe aportar documento acreditativo de su identidad.
                    Puede contactar con el Delegado de Protección de Datos a través de email: dpd@emvs.es, y reclamar ante
                    la Agencia Española de Protección de datos, en caso de que no obtenga la respuesta
                    pretendida.
                    La información ampliada sobre protección de datos se encuentra en:
                    <strong>https://www.emvs.es/terminos-y-condiciones/autorizacion-de-consulta</strong>
                  </p>
                </div>
                <div class="col-sm-12">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button [disabled]="submitConsulta" type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button [disabled]="submitConsulta" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>                  
                   <!-- <button [disabled]="submitConsulta" type="submit" class="btn btn-primary mt-2">{{ 'TRAMITE.CONTENT.FINALIZAR' | translate }}</button>-->
                    <fieldset [disabled]="submitConsulta">
                      <boton-listado>                  
                      </boton-listado>
                    </fieldset>                  
                  </div>
                </div>
              </form>
            </div>
  
            <div class="tab-pane fade" id="instancia" role="tabpanel" aria-labelledby="instancia-tab">
              <form [formGroup]="formInstancia" (ngSubmit)="onSubmitInstancia()">
                <h3 class="w-100 tabtitle">Expone</h3>
                <textarea rows="4" class="w-100" formControlName="expone" [ngClass]="{'invalid-textarea': submitInstancia && this.formInstancia.controls['expone'].errors}"></textarea>
  
                <h3 class="w-100 tabtitle">Solicita</h3>
                <textarea rows="4" class="w-100" formControlName="solicita" [ngClass]="{'invalid-textarea': submitInstancia && this.formInstancia.controls['solicita'].errors}"></textarea>
  
                <h3 class="w-100 tabtitle">Archivos adjuntos</h3>
                <div class="col-sm-12">
                  <div class="col-sm-12 d-flex align-items-center">
                    <p class="col-sm-6 spacing-box">{{ 'TRAMITE.CONTENT.ADJUNTAR_DOCUMENTOS' | translate }}</p>
                    <div class="custom-file">
                      <input type="file"  accept="application/pdf" class="custom-file-input" id="customFileLang" (change)="handleUpload($event)">
                      <label class="custom-file-label" data-browse="Elegir" for="customFileLang">{{ 'TRAMITE.FORM.LABEL.SELECCIONAR_ARCHIVO' | translate }}</label>
                    </div>
                  </div>
                  <table class="table table-striped">
                    <tr>
                      <td class="tinyLabel">{{ 'TRAMITE.CONTENT.NOMBRE_DOCUMENTO' | translate }}</td>
                    </tr>
                    <tr *ngFor="let documento of this.mapDocumentos">
                      <td>{{documento['nameDocument'] }}</td>
                      <td><button (click)="removeFile(mapDocumentos.indexOf(documento))"
                          class="btn btn-danger">{{ 'TRAMITE.FILE.DELETE' | translate }}</button></td>
                    </tr>
                  </table>  
                </div>
                <div class="col-sm-12">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button [disabled]="uploadDocuments" type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button [disabled]="uploadDocuments" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>                    
                    <button [disabled]="uploadDocuments" type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form id="firma" (submit)="resultchange($event)" class="">
      <input type="hidden" id="result" />
      <input type="hidden" id="error" />
      <input type="hidden" id="certifcado" />
    </form>
  
  </div>